import {BrandApplePodcast, Car, Cards, Icon, Logout, ServerCog, Users, Vinyl} from 'tabler-icons-react';

export enum Role {
    Admin = "admin",                     // 1. Админ
    Manager = "manager",                 // 2. Менеджер
    Moderator = "moderator",             // 3. Модератор
    RealistModerator = "moderatorRealista", // 4. Модератор реалиста
    Watcher = "watcher"                  // 5. Наблюдатель (watcher)
}

export const authRoles: Record<string, Role[]> = {
    admin: [Role.Admin],
    manager: [Role.Admin, Role.Manager],
    moderator: [Role.Admin, Role.Moderator, Role.Manager],
    realistModerator: [Role.Admin, Role.Moderator, Role.RealistModerator, Role.Manager],
    watcher: [Role.Admin, Role.Moderator, Role.RealistModerator, Role.Manager, Role.Watcher],
};


export interface Item {
    title: string;
    isAdmin?: boolean;
    icon: JSX.Element;
    href: string;
    auth?: Role[];
}

export const Items:Item[]  = [
    {
        title: "Лиды на модерации",
        isAdmin: false,
        icon: <ServerCog size={24} className="menu-icon"  />,
        href: "/leads",
    },

    {
        title: "Причины модерации",
        isAdmin: true,
        icon: <BrandApplePodcast size={24} className="menu-icon"  />,
        href: "/cause",
        auth: authRoles.realistModerator,
    },

    {
        title: "Загрузка записей",
        isAdmin: true,
        icon: <Vinyl size={24} className="menu-icon"  />,
        href: "/amofile",
        auth: authRoles.realistModerator,
    },
    {
        title: "Загрузка лида/файла авто",
        isAdmin: true,
        icon: <Car size={24} className="menu-icon"  />,
        href: "/amocar",
        auth: authRoles.realistModerator,
    },
    {
        title: "Загрузка лида/файла авто xlsx",
        isAdmin: true,
        icon: <Cards size={24} className="menu-icon"  />,
        href: "/car-excel",
        auth: authRoles.realistModerator,
    },
    {
        title: "Учетные записи",
        isAdmin: true,
        icon: <Users size={24} className="menu-icon"  />,
        href: "/user",
        auth: authRoles.realistModerator,
    },
    {
        title: "Выход",
        icon: <Logout size={24} className="menu-icon" />,
        href: "/exit",
    },

]

export const ItemsNotAdmin = [
    {
        title: "Загрузка лида/файла авто",
        isAdmin: true,
        icon: <Car size={24} className="menu-icon"  />,
        href: "/amocar",
    },
    {
        title: "Загрузка лида/файла авто xlsx",
        isAdmin: true,
        icon: <Cards size={24} className="menu-icon"  />,
        href: "/car-excel",
    },
    {
        title: "Выход",
        icon: <Logout size={24} className="menu-icon" />,
        href: "/exit",
    }
]